'use strict';

angular.module('DispatcherModule', [])


/**
 * Dispatcher Service
 * @ngdoc Factory
 * Load data provided in publicConfiguration variable with the provided templates and bind them togther.
 */

    .factory('DispatcherServices', ['$http', '$stateParams', '$location', '$q', '$log', '$cookies', 'localize', 'hUser', '$filter', 'asyncGlobalHandler', 'httpHelper', '$injector', '$compile', '$rootScope',
        function ($http, $stateParams, $location, $q, $log, $cookies, localize, hUser, $filter, asyncGlobalHandler, httpHelper, $injector, $compile, $rootScope) {
        var factory = {};


        factory.publicConfigurationURLKeyMaping = [];
        factory.getURLKey = function () {
            return factory.publicConfigurationURLKeyMaping[$location.path()];
        };

        /**
         * Get Configuration
         * Load configurations from publicConfiguration variable
         */
        factory.getConfig = function (type) {
            if (type) {
                try {
                    return publicConfiguration[type];
                } catch (e) {
                    $log.error("configuration type not found", type);
                }
            }
            return publicConfiguration;
        };

        /**
         * Get Route Configuration, it will load all route configurations if the url param is not provided.
         * @param String url (optional)
         */
        factory.getRouteConfig = function (url) {
            try {
                var config = factory.getConfig("routes")[url];

                if (!config) {
                    config = {};
                }

                return config;
            } catch (e) {
                $log.error("url route not found", url);
            }
        };

        /**
         * Public data is specifed in publicConfiguration.publicData variable. Use it to share data among all the system.
         */
        factory.getAllPublicData = function () {
            return factory.getConfig('publicData');
        };

        /**
         * Public data is specifed in publicConfiguration.publicData[id] variable. Use it to share data among all the system.
         * @param String id load public data with the specifed id.
         */
        factory.getPublicData = function (id) {
            return factory.getAllPublicData()[id];
        };

        /**
         * Public functions are part of publicConfiguration.functions, use it to share functions among the system.
         */
        factory.getAllFunctions = function () {
            return factory.getConfig('functions');
        };

        /**
         * Load specific function from the Public functions that are part of publicConfiguration.functions, use it to share functions among the system.
         * @param String functionName specify function name to get loaded
         */
        factory.getFunction = function (functionName) {
            try {
                return factory.getAllFunctions()[functionName];
            } catch (e) {
                $log.error("function name undefined = ", functionName);
            }
        };

        /**
         * Bind params variable with urls. example: it will bind {id:5} with url /get/job/:id to /get/job/5
         * @param String url url with variables to be replaced with the values from params. Variables should have `:` in front. Example: /job/:id
         * @param JSON params a key value object that's hold params.
         */
        factory.bindURLWithParams = function (url, params) {
            return factory.getFunction('bindURLWithParams')(url, params);
        };

        /**
         * Merge JSON value into one variable. Example: it will merge {"res":{"jobs":{["Bartender", "Server"]}}, "MenuRes":{"menu":["home","about"]} } into {"jobs":{["Bartender", "Server"]}, "menu":{["home","about"]} }
         * @param String url url with variables to be replaced with the values from params. Variables should have `:` in front. Example: /job/:id
         * @param JSON params a key value object that's hold params.
         */
        factory.publicDataMappingCallback = function (data, routeParams) {
            return factory.getFunction('publicDataMappingCallback')(data, routeParams, factory.getAllFunctions());
        };

        /**
         * loadedData holds all the static data that already added either to the route configs or to publicData in publicConfiguration variable.
         * It contains the data aggrigated based on the URL for a specific route.
         */
        factory.loadedData = {};

        /**
         * asyncLoadingObjects holds all requested APIs $http object that are specifed in the route configs in publicConfiguration variable.
         */
        factory.asyncLoadingObjects = {};


        /*
         * Prepare data holders and route data elements.
         * @param String url route url
         * @param JSON params a json represation of the varliables sent in the request.
         */
        factory.prepareAllData = function (url, params, routeConfig) {
            var data;
            try {
                data = routeConfig.data;
            } catch (e) {
                console.warn("Data Error", e);
                return;
            }

            //flush data holders
            factory.loadedData[url] = {};
            factory.asyncLoadingObjects[url] = {};

            for (var i in data) {
                factory.prepareDataElement(data[i], url, params, routeConfig);
            }
        };

        /*
         * Load data either from a url or a static data source.
         * @param JSON data data element from the route config, example: {"type":"url","link":"http://localhost:9000/api/awesomeThings","id":"jobs"},
         * @param String url route url.
         */
        factory.prepareDataElement = function (data, url, params, route) {
            /*
             * Data Element Types:
             * url: a full url.
             * api: prefixed with APIServerBaseURL from the publicConfiguration.
             * static-data: loads data from publicData in publicConfiguration.
             * data: hardcoded data in the data.data
             */
            if (data.type.toLowerCase() == "url" || data.type.toLowerCase() == "api") {
                var link = data.link;

                if (data.type.toLowerCase() == "api" && link.indexOf('://') < 0) {
                    link = factory.getConfig("APIServerBaseURL") + link;
                    if (data.version) {
                        link = link.replace('v1', data.version);
                    }

                }
                link = factory.bindURLWithParams(link, params);

                if (!data['nodejs_only']) {

                    if (data.method && data.method.toLowerCase() == 'post') {
                        var body = data.prepareBody(params);

                        factory.asyncLoadingObjects[url][data.id] = httpHelper.safePost(link,body ,false);
                    } else {
                        if (data.prepareLinkParams) {
                            link = link + data.prepareLinkParams(route);
                        }

                        factory.asyncLoadingObjects[url][data.id] = httpHelper.safeGet(link, false, data.headers);
                    }
                }

            } else if (data.type.toLowerCase() == "static-data") {

                factory.loadedData[url][data.id] = publicConfiguration.publicData[data.id];

            } else if (data.type.toLowerCase() == "data") {

                factory.loadedData[url][data.id] = data.data;

            }
        };
        /*
         * Wait for all the async Loaders and merge the data either by the public or specified function.
         * @param String url route url
         * @param JSON params a json represation of the varliables sent in the request.
         * @param function completeCallback it will be called after all the data are successfully laoded,
         * and the following values will be sent url, data, routeConfig, publicFunctions
         */
        factory.loadData = function (routeConfig, url, locationURL, params, completeCallback) {

            factory.prepareAllData(url, params, routeConfig);

//    var routeConfig = factory.getRouteConfig(url);
//    wait for the asyncLoadingObjects to get loaded
            var promise = $q.all(factory.asyncLoadingObjects[url]);
            asyncGlobalHandler.watchPromise(promise);

            promise.then(function (asyncLoaders) {
                var asyncloadedData = [];
                for (var i in factory.asyncLoadingObjects[url]) {
                    //get the data from the asyncLoaders.
                    asyncloadedData[i] = asyncLoaders[i].data;
                    if (asyncloadedData[i].data) {
                        asyncloadedData[i].data.isPrivateLink = routeConfig.isPrivateLink;
                        asyncloadedData[i].data.isPrivateViaLinkJob = routeConfig.isPrivateViaLinkJob;
                        if (routeConfig.privateJobKey) {
                            asyncloadedData[i].data.privateJobKey = routeConfig.privateJobKey;
                        }
                        asyncloadedData[i].data.isPrivateCareerPortalEnabled = routeConfig.isPrivateCareerPortalEnabled;
                    }
                }

                //merge all the data(static, data, and async Loaded data) through either the public or the route config data mapping funciton.
                var data = factory.publicDataMappingCallback([factory.loadedData[url], asyncloadedData]);
                if (routeConfig.dataMappingCallback) {

                    var params = [data, routeConfig, factory.getAllFunctions()];
                    if (routeConfig.dataMappingDependencies) {
                        for (var i in routeConfig.dataMappingDependencies) {
                            params.push($injector.get(routeConfig.dataMappingDependencies[i]));
                        }
                    }

                    data = routeConfig.dataMappingCallback.apply(this, params);
                } else {
                    data = factory.publicDataMappingCallback(data, routeConfig, factory.getAllFunctions());
                }

                //adding params to data
                data.params = $stateParams;

                //adding cookies to data
                data.cookies = $cookies;

                //user informationapp/modules/forms/views/interview.html
                data.hUser = hUser.data.user;
                data.isLoggedIn = hUser.isLoggedIn();

                //add url
                data.request = {url: $location.path()};

                //sent lang information to view
                data.lang = localize.getLang();
                data.supportedLanguages = publicConfiguration.i18n.supportedLanguages;


                if (completeCallback) {
                    completeCallback(data, url, routeConfig, factory.getAllFunctions(), locationURL);
                }
            });
        };

        /*
         * Load and inject head tags.
         * @param String URLKey route url
         * @param JSON data merged data that's loaded from loadData function.
         */
        factory.updateHeadTags = function (URLKey, data, routeConfig) {
//      var routeConfig = factory.getRouteConfig(URLKey);

            //generate header tags. ex: title, scripts, meta
            var metaGeneratorTemplate = factory.getConfig("head")['metaGeneratorTemplate'];

            var headTagsConfig = factory.getConfig("head")['defaultHeadTags'];

            if (routeConfig.headTags && routeConfig.headTags.length > 0) {
                headTagsConfig = routeConfig.headTags;
            }

            var nunjucks = factory.getNunjucks();
            //bind template with header tags.
            var headTags = nunjucks.renderString(metaGeneratorTemplate, { 'tags': headTagsConfig});
            //bind header with actual data
            headTags = nunjucks.renderString(headTags, data);

            //replace title, and base tags in head
            for (var k in headTagsConfig) {
                var headElement = headTagsConfig[k];
                if (headElement.tag.toLowerCase() == "title") {
                    $('head title').remove();
                }
                if (headElement.tag.toLowerCase() == "base") {
                    $('head base').remove();
                }
            }

            //append the new tags
            $('head').append(headTags);
        };

        /*
         * Load the template and all associated views.
         * @param String url route url
         * @param String templateUrl
         * @param JSON data merged data that's loaded from loadData function.
         * @param function completeCallback it will be called after all the template views are successfully laoded.
         */
        factory.loadView = function (url, locationURL, templateUrl, template, data, completeCallback) {

            var customLocations = ['harri', 'Nathaniel'];
            var tempLocation = [];
            var formatLocations = false;
            var locationsToFormat;
            var type;


            // @TODO karmi fixed this. ask him why?
            if ($('body').hasClass('modal-open')) {
                $('body').removeClass('modal-open');
            }


            let render;
            const nunjucks = factory.getNunjucks()
            if (template) {
                render = nunjucks.renderString.bind(nunjucks);
            } else {
                render = nunjucks.render.bind(nunjucks);
            }

            render(template || templateUrl, data, function (err, html) {
                if (err) {
                    $log.error(err, template || templateUrl, data);
                }

                if (completeCallback) {
                    completeCallback(html, data);
                }
            });


        };

        /*
         * Load all the dynamic and static data which are specifed in the publicConfiguration and call a callback once they are loaded.
         * @param function completeCallback it will be called after all the data are successfully laoded.
         */
        factory.getData = function ($stateParams, routeConfig, completeCallback) {
            var locationURL = $location.path();
            factory.loadData(routeConfig, $location.path(), locationURL, $stateParams, function (data, url, routeConfig, allPublicFunctions, locationURL) {

                //factory.updateHeadTags(url, data, routeConfig);

                if (completeCallback) {
                    completeCallback(data, url, routeConfig, allPublicFunctions, locationURL);
                }
            });
        };

        /*
         * Load all the data and the template views together and place them in the screen.
         * @param function completeCallback a call back that will be fired after all data and template views are loaded.
         */
        factory.load = function (routeConfig, completeCallback) {

            factory.getData($stateParams, routeConfig, function (data, url, routeConfig, allPublicFunctions, locationURL) {
                factory.loadView(url, locationURL, routeConfig.nunJucksTemplateUrl, routeConfig.nunJucksTemplate, data, function (html) {
                    if (completeCallback) {
                        completeCallback(url, html, data, routeConfig, factory.getAllFunctions());
                    }
                });
            });
        };


        /*
         * Load all the data and the template views together and place them in the screen.
         */
        factory.evaluate = function ($scope, $compile, routeConfig, completeCallback, params) {

            //add more params to default ui-routing params
            for (var k in params) {
                $stateParams[k] = params[k]
            }

            factory.load(routeConfig, function (url, html, data, routeConfig, allPublicFunctions) {

                if (completeCallback) {
                    completeCallback(url, html, data, routeConfig, allPublicFunctions);
                }

            });
        };


        factory.nunjucks;
        /*
         * return global-static nunjucks Environment variable.
         */
        factory.getNunjucks = function () {

            if (!factory.nunjucks) {
                var harriLoader = nunjucks.WebLoader.extend({
                    async: false,
                    resolve: function(from, to) {
                        return to;
                    },
                    getSource: function(name, callback) {
                        if (typeof(window) != 'undefined') {

                            window.nunjucksPrecompiled = window.nunjucksPrecompiled || {};
                            window.nunjuckstemplates = window.nunjuckstemplates || {};

                            if (window.nunjucksPrecompiled && window.nunjucksPrecompiled[name]) {
                                // A compiled version is already here
                                return {
                                    src: {
                                        type: 'code',
                                        obj: window.nunjucksPrecompiled[name]
                                    },
                                    path: name
                                };
                            }

                            var html = "";

                            if(window.nunjuckstemplates[name]) {
                                // An already loaded template exists, use it instead of loading a new one
                                html = window.nunjuckstemplates[name];
                            }
                            else {

                                // Load the template using an ajax request
                                jQuery.ajax({
                                    url: name,
                                    success: function (res) {
                                        html = res;
                                    },
                                    async: false
                                });

                                window.nunjuckstemplates[name] = html;
                            }

                            return {
                                src: html,
                                path: name,
                                noCache: false
                            };
                        }
                        else {
                            console.warn("Harri Nunjucks loader doesn't support Node.js");
                        }
                    }
                });

                factory.nunjucks = new nunjucks.Environment(new harriLoader("", false), {
                    autoescape: true
                });

                // Work around, remove default nunjucks loader
                // Default loader fails due to an internal error in Nunjucks
                factory.nunjucks.loaders.splice(0, 1);

                //set the filter in ASYNC.
                factory.nunjucks.addFilter('translate', function (text, callback) {

                    var translatedText = lang[text] || text;
                    //var translatedText = lang[text] || text;
                    if(!callback) {
                        return translatedText;
                    }
                    callback("", translatedText);

                    return translatedText;

//                    //callback once the launguge is loaded.
//                    localize.asyncLocalizedString(text, function (translatedText) {
//                        //nunjucks callback style
//                        callback("", translatedText);
//                        return translatedText;
//                    });

                }, true);


                factory.nunjucks.addFilter('dateGreaterThanNow', function (time, callback) {
                    return moment(time).isAfter();
                }, false);

                factory.nunjucks.addFilter('formatDateFromNow', function (text, callback) {
                    return moment().add(text, 'd').format('l');
                }, false);

                factory.nunjucks.addFilter('formatLocation', function (text, type, callback) {
                    return $filter('formatLocation')(text, type);
                }, false);

                factory.nunjucks.addFilter('formatJobApplyLocations', function (text, callback) {
                    return $filter('formatJobApplyLocations')(text);
                }, false);

                factory.nunjucks.addFilter('formatWorkPeriod', function (startdate, enddate, callback) {
                    return $filter('formatWorkPeriod')(startdate, enddate);
                }, false);

                factory.nunjucks.addFilter('compensationFormatter', function (compensationObj, brand) {
                    return $filter('compensationFormatter')(compensationObj, brand);
                }, false);

                factory.nunjucks.addFilter('locationCurrencySymbol', function (brand) {
                    return $filter('locationCurrencySymbol')(brand);
                }, false);

                factory.nunjucks.addFilter('calculatePercentage', function (price, originalPrice, callback) {
                    return $filter('calculatePercentage')(price, originalPrice);
                }, false);

                factory.nunjucks.addFilter('formatDate', function (time, format, callback) {
                    return $filter('formatDate')(time, format);
                }, false);

                factory.nunjucks.addFilter('formatDateIgnoreTimeZone', function (time, format, callback) {
                    return $filter('formatDateIgnoreTimeZone')(time, format);
                }, false);

                factory.nunjucks.addFilter('formatHours', function (time, showSeconds, TimeFormat, forExcel, callback) {
                    return $filter('formatHours')(time, showSeconds, TimeFormat, forExcel);
                }, false);

                factory.nunjucks.addFilter('dateDifferenceSeconds', function (start, end, callback) {
                    return $filter('dateDifferenceSeconds')(start, end);
                }, false);

                 factory.nunjucks.addFilter('dateDifferenceAsDays', function (start, end, callback) {
                    return $filter('dateDifferenceAsDays')(start, end);
                }, false);

                factory.nunjucks.addFilter('userPosition', function (workObj, callback) {
                    return $filter('userPosition')(workObj);
                }, false);


                factory.nunjucks.addFilter('formatPeriod', function (workObj, callback) {
                    return $filter('formatPeriod')(workObj);
                }, false);

                factory.nunjucks.addFilter('nl2br', function (msg,is_xhtml, callback) {
                    return $filter('nl2br')(msg,is_xhtml);
                }, false);

                factory.nunjucks.addFilter('jobEndTime', function (date, callback) {
                    return $filter('jobEndTime')(date);
                }, false);

                factory.nunjucks.addFilter('termFormatterToSearch', function (term, callback) {
                  return $filter('termFormatterToSearch')(term);
                }, false);

                factory.nunjucks.addFilter('cut', function (value, wordwise, max, tail, callback) {
                  return $filter('cut')(value, wordwise, max, tail);
                }, false);

                factory.nunjucks.addFilter('username', function (term, callback) {
                  return $filter('username')(term);
                }, false);

                factory.nunjucks.addFilter('formatLongJobLocation', function (locations, callback) {
                  return $filter('formatLongJobLocation')(locations);
                }, false);

                //Type checking filter
                factory.nunjucks.addFilter('type', function (variable) {
                    return typeof(variable);
                }, false);

                factory.nunjucks.addFilter('currency', function (amount, symbol, fractionSize) {
                    return $filter('currency')(amount, symbol, fractionSize);
                }, false);

                factory.nunjucks.addFilter('wordsInitialChars', function (laebl) {
                    return $filter('wordsInitialChars')(laebl);
                }, false);

                factory.nunjucks.addFilter('formatNumber', function (number, format, symbol, value2) {
                    return $filter('formatNumber')(number, format, symbol, value2);
                }, false);

                factory.nunjucks.addFilter('formatDurationWithText', function (number) {
                    return $filter('formatDurationWithText')(number);
                }, false);

                factory.nunjucks.addFilter('hChartsNumber', function (value, options) {
                    return $filter('hChartsNumber')(value, options);
                }, false);

                factory.nunjucks.addFilter('fromNow', function (date) {
                    return $filter('fromNow')(date);
                }, false);

                // Attach filters to nunjucks - these filters are same for backend/frontend
                // TODO: Move all filters to the wrapper
                factory.nunjucks = new NunjucksWrapper(factory.nunjucks, Utils).init();
                window.HNotifications.init(factory.nunjucks, $compile, $rootScope);
            }


            return factory.nunjucks;
        };

        return factory;

    }]).config(["$locationProvider", "$sceDelegateProvider", "$stateProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", function ($locationProvider, $sceDelegateProvider, $stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider) {
        var dynamicTemplate = {};
        var isBot = false;
        var ua = navigator.userAgent;
        if (ua.match(/curl|Bot|B-O-T|Crawler|Spider|Spyder|Yahoo|ia_archiver|Covario-IDS|findlinks|DataparkSearch|larbin|Mediapartners-Google|NG-Search|Snappy|Teoma|Jeeves|Charlotte|NewsGator|TinEye|Cerberian|SearchSight|Zao|Scrubby|Qseero|PycURL|Pompos|oegp|SBIder|yoogliFetchAgent|yacy|webcollage|VYU2|voyager|updated|truwoGPS|StackRambler|Sqworm|silk|semanticdiscovery|ScoutJet|Nymesis|NetResearchServer|MVAClient|mogimogi|Mnogosearch|Arachmo|Accoona|holmes|htdig|ichiro|webis|LinkWalker|lwp-trivial|facebookexternalhit/i) && !ua.match(/phone|Playstation/i)) {
            // if user agent is a BOT/Crawler/Spider
            isBot = true;
        }

        //ignore all the configurations if the request is coming from a bot engine
        if (isBot) {
            return;
        }

        $urlMatcherFactoryProvider.strictMode(false);

        //allow access to diffrent links through AngularJS
        try {
            $sceDelegateProvider.resourceUrlWhitelist([
                // Allow same origin resource loads.
                'self',

                //api server url
                publicConfiguration.APIServerBaseURL,

                // Allow loading from outer templates domain.
                'https:' + CDNHost + '**',
                'https://harri-wordpress-content.s3.amazonaws.com/' + '**',
            ]);
        } catch (e) {
        }

//            //https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions#how-to-make-a-trailing-slash-optional-for-all-routes
//            $urlRouterProvider.rule(function ($injector, $location) {
//                var path = $location.url();
//
//                // check to see if the path already has a slash where it should be
//                if (path[path.length - 1] === '/' || path.indexOf('/?') > -1) {
//                    return;
//                }
//
//                if (path.indexOf('?') > -1) {
//                    return path.replace('?', '/?');
//                }
//
//                return path;
//            });

        //initialize configured routes
        var counter = 0;

        for (var URLKey in publicConfiguration['routes']) {
            counter++;

            var routeConfig = publicConfiguration['routes'][URLKey];

            if(deviceChecker.isMobile() && routeConfig.desktopOnly) {
                continue;
            } else if (!deviceChecker.isMobile() && routeConfig.mobileOnly) {
                continue;
            }

            if (routeConfig.type != "backend") {

                //Match page URL with config URL and save them.
                (function (url, routeConfig) {

                    if (!routeConfig.url) {
                        routeConfig.url = URLKey;
                    }


                    /**
                     * Attach gid ,clear_context to Parent Route that wraps Source Hire & Team Routes
                     * This to avoid duplication of the params in url
                     */

                    if (
                        routeConfig.name &&
                        ['appLayout'].indexOf(routeConfig.name) > -1
                    ) {
                        routeConfig.url = addQueryToURL(routeConfig.url, 'gid');
                        routeConfig.url = addQueryToURL(routeConfig.url, 'clear_context');
                    }


                    //removing the ||||DUPLICATE|||| from the url key, that's because in
                    // JS it will consider propirties with the same key as on property
                    routeConfig.url = routeConfig.url.replace("||||DUPLICATE||||", "");
                    if (routeConfig.name == 'job-post') {
                        routeConfig.url = addQueryToURL(routeConfig.url, 'pjt');
                    }

                    if(routeConfig.enableUTM === true) {
                        routeConfig.url = addQueryToURL(routeConfig.url,'utm_source&utm_medium&utm_content&utm_campaign&utm_term&job_referrer_id&social_media_channel','utm_source');
                    }

                    if(routeConfig.enableUsernameReferral === true){
                      //routeConfig.url = addQueryToURL(routeConfig.url,'r','?r=');
                    }

                    if(routeConfig.customQueryURL) {
                        routeConfig.url = addQueryToURL(routeConfig.url, routeConfig.customQueryURL);
                    }

                    //nunjucks add views automatically and so we need to handle it on other parts
                    if (routeConfig.templateUrl && routeConfig.type != "backend-frontend" && CDNUri == "" && !routeConfig.isExternalTemplate){
                        routeConfig.templateUrl = 'views/' + routeConfig.templateUrl;
                    }

                    if (routeConfig.views && CDNUri == "") {
                        for (var kk in routeConfig.views) {
                            if (routeConfig.views[kk].templateUrl) {
                                routeConfig.views[kk].templateUrl = 'views/' + routeConfig.views[kk].templateUrl;
                            }
                        }
                    }

                    routeConfig['resolve'] = routeConfig['resolve'] || {};
                    routeConfig['resolve']['lazyLoad'] = ['$q', 'dependenciesLoaderService', 'cssLoaderService', function ($q, dependenciesLoaderService, cssLoaderService) {
                        var styleInjector;
                        var cssPromise = cssLoaderService.load(routeConfig['route_styles'], true)
                            .then(function (injector) {
                                styleInjector = injector;
                            });

                        return $q.all([
                            cssPromise,
                            dependenciesLoaderService.load(routeConfig['route_dependencies'] || [])
                        ]).finally(function () {
                            // Apply styles to DOM just before resolving the route
                            styleInjector && styleInjector();
                        });
                    }];

                    if ((routeConfig.template || routeConfig.templateUrl || routeConfig.controllers) && routeConfig.type == "backend-frontend") {

                        routeConfig.nunJucksTemplateUrl = routeConfig.templateUrl;
                        routeConfig.nunJucksTemplate = routeConfig.template;

                        delete routeConfig.templateUrl;
                        delete routeConfig.template;

                        routeConfig.templateProvider = ['$compile', 'DispatcherServices', '$rootScope', '$q', '$location', '$stateParams', '$cacheFactory', 'httpHelper',
                            function ($compile, DispatcherServices, $rootScope, $q, $location, $stateParams, $cacheFactory, httpHelper) {

                                var mainDefer = $q.defer();

                                var promise = [];

                                if (routeConfig["dynamic-template"]) {
                                    //update slug information into $params
                                    promise = parseSlugAndInjectItIntoParams($location, $cacheFactory, $stateParams, httpHelper, $q);
                                }

                                $q.when(promise).then(function (result) {
                                    var routeName = routeConfig.name.replace("internal-", "");

                                    let controller;
                                    if (routeName == 'employer' && result.career_portal_enabled && !$stateParams.brand_view && ($location.path().indexOf('/media/') == -1)) {
                                        controller = routeConfig.controllers.gpCareerPortal;
                                    } else if (routeName == 'employer') {
                                        controller = routeConfig.controllers.brand;
                                    } else if (routeName === 'career-portal-story' || routeName === 'career-portal-story-preview') {
                                        controller = routeConfig.controllers.CareerStoryPageContainer;
                                    }

                                    if (controller) {
                                        routeConfig.nunJucksTemplateUrl = controller.templateUrl;
                                        routeConfig.nunJucksTemplate = controller.template;
                                        routeConfig.data = controller.data;
                                    }

                                    routeConfig.isPrivateCareerPortalEnabled = result.isPrivateCareerPortalEnabled;
                                    routeConfig.isPrivateLink = result.isPrivateLink;
                                    routeConfig.isPrivateViaLinkJob = result.isPrivateViaLinkJob;
                                    if (result.privateJobKey) {
                                        routeConfig.privateJobKey = result.privateJobKey;
                                    }

                                    DispatcherServices.evaluate($rootScope, $compile, routeConfig, function (url, html, data, routeConfig, allPublicFunctions) {
                                        //update data object for headtags
                                        if(data.basicInfo){
                                            data.basicInfo.slug = result.slug;
                                            data.data = {};
                                            data.data.name =  data.basicInfo.name;
                                            data.data.description =  (data.basicInfo.description) ? data.basicInfo.description : data.basicInfo.name;
                                        }
                                        //load head tags in the route contains template in anykind
                                        DispatcherServices.updateHeadTags(url, data, routeConfig);
                                        mainDefer.resolve(html);
                                    }, $stateParams);

                                });

                                return mainDefer.promise;
                            }
                        ];

                    } else {
                        //load head tags in the route does not contains template in anykind
                        if (routeConfig.type == "frontend" || routeConfig.type == "backend-frontend") {

                            if (!routeConfig.resolve) {
                                routeConfig.resolve = {};
                            }

                            routeConfig.resolve.headerTags = ['$stateParams', 'DispatcherServices', function ($stateParams, DispatcherServices) {
                                DispatcherServices.getData($stateParams, routeConfig, function (data, url, routeConfig, allPublicFunctions, locationURL) {
                                    DispatcherServices.updateHeadTags(url, data, routeConfig);
                                });
                            }]
                        }
                    }

                    if (!routeConfig.resolve) {
                        routeConfig.resolve = {};
                    }

                    //if mobile - drop parent stage and replace the main view
                    if(deviceChecker.isMobile()) {
                        if (routeConfig.modal) {
                            for (var k in routeConfig.views) {
                                routeConfig.views["@"] = routeConfig.views[k];
                                delete routeConfig.views[k];
                                break;
                            }
                        }
                    }


                    if (!routeConfig.name) {
                        routeConfig.name = "route" + counter;
                    }

                    //hold the final result of dynamic-template for future updates
                    if (routeConfig["dynamic-template"]) {

                        //if not found create an array (example: routeConfig["dynamic-template"]="candidate")
                        if (!dynamicTemplate[routeConfig["dynamic-template"]]) {
                            dynamicTemplate[routeConfig["dynamic-template"]] = [];
                        }

                        dynamicTemplate[routeConfig["dynamic-template"]].push(routeConfig);
                    } else {
                        //push the new state only if it's not a template
                        try {
                            $stateProvider.state(routeConfig.name, routeConfig);
                        }
                        catch (e) {
                            console.error(routeConfig);
                            console.error(e);
                        }
                    }

                })(URLKey, routeConfig);


                var otherwiseUrls = {};
                //handle dynamic member + brand slugs + 404 error page
                $urlRouterProvider.otherwise(function ($injector, $location) {


                    //handle hashes in the url
                    if($location.hash() && $location.hash() != "") {
                        $location.hash('');
                        hRedirect(window.location.href);
                        return;
                    }


                    var $state = $injector.get("$state");
                    var $stateParams = $injector.get("$stateParams");

                    function notFound() {
                        $state.go("404", {}, {location: false});
                    }

                    function reload() {
                        //refresh the page
                        var $urlRouter = $injector.get("$urlRouter");
                        $urlRouter.sync();
                    }

                    var url = $location.url();
                    if(otherwiseUrls[url]) {
                        notFound();
                        return;
                    } else {
                        otherwiseUrls[url] = true;
                    }

                    var promise = parseSlugAndInjectItIntoParams($location, $injector.get("$cacheFactory"), $stateParams, $injector.get("httpHelper"), $injector.get("$q"));
                    promise.then(function (urlType) {

                        if (urlType.cached) {
                            reload();
                        } else {
                            var memberType = urlType.type; //brand | member
                            if (dynamicTemplate[memberType]) {
                                var routes = dynamicTemplate[memberType];
                                for (var k in routes) {
                                    //make a copy for diffrent candidate
                                    var route = {};
                                    angular.copy(routes[k], route);

                                    var regexpString = memberType + "%slug";
                                    var newString = urlType.slug;

                                    if (urlType.isPrivateLink && (!urlType.career_portal_enabled || urlType.isPrivateCareerPortalEnabled)) {
                                        newString = "internal/" + newString;
                                    }

                                    route.url = route.url.replace(regexpString, newString, "gi"); //brand%slug or member%slug

                                    //removing the ||||DUPLICATE|||| from the url key, that's because in
                                    // JS it will consider propirties with the same key as on property
                                    route.url = route.url.replace("||||DUPLICATE||||", "");

                                    route.name = urlType.slug.replace(/[^a-zA-Z0-9-_]/g, '') + "_" + route.name;
                                    route.slug = urlType.slug;

                                    if (urlType.isPrivateLink && (!urlType.career_portal_enabled || urlType.isPrivateCareerPortalEnabled)) {
                                        route.name = "internal-" + route.name;
                                        route.slug = "internal-" + route.slug;
                                        route.isPrivateLink = true;
                                    }

                                    route.isPrivateViaLinkJob =  urlType.isPrivateViaLinkJob;
                                    if (urlType.privateJobKey) {
                                        route.privateJobKey = urlType.privateJobKey;
                                    }

                                    //assign new state
                                    $stateProvider.state(route.name, route);
                                }
                            }
                            reload();
                        }
                    }, function () {
                        notFound();
                    });

                    var asyncGlobalHandler = $injector.get("asyncGlobalHandler");
                    asyncGlobalHandler.watchPromise(promise);
                })

            }

        }


        function parseSlugAndInjectItIntoParams($location, $cacheFactory, $stateParams, httpHelper, $q) {
            var defer = $q.defer();

            function bindDatawithStateParams(slug, cachedSlug, isInternalSlug) {

                slug = decodeURIComponent(slug);

                var result = {};
                result.id =  cachedSlug.id;
                result.type =  cachedSlug.type;
                result.slug =  slug;
                result.isPrivateCareerPortalEnabled = cachedSlug.private_career_portal_enabled;
                result.isPrivateLink = ([4246740, 4241280, 4239538].indexOf(result['id']) > -1) || isInternalSlug;
                result.career_portal_enabled = cachedSlug.career_portal_enabled;
                result.isPrivateViaLinkJob = privateJobKey ? true : false;
                result.careerStoryPageEnabled = cachedSlug.career_story_page_enabled;
                result.hasCareerStoryPageSettings = !!cachedSlug.has_career_story_page_settings;

                if (privateJobKey) {
                    result.privateJobKey = privateJobKey;
                }

                //@TODO: find a better solution and remove this from window object
                //save the result in window obj to solve overide by any nested states
                //this var should be removed when leaving state
                return window.stateParams = result;
            }

            var url = $location.url();
            var slug;
            var isInternalSlug = false;
            var privateJobKey = '';

            if (url && url.length > 1) {
                var urlParts = url.split("/");

                if (urlParts[1] === 'internal' && urlParts.length > 1) {
                    isInternalSlug = true;
                    slug = urlParts[2];
                } else if (urlParts[1] === 'careers' && urlParts.length > 1) {
                    slug = urlParts[2];
                } else {
                    slug = urlParts[1];
                }

                if (url.indexOf("pjt=") > -1) {
                    privateJobKey = url.substring(url.indexOf("pjt=") + 4);
                }
            }

            if(slug.indexOf('?') >= 0) {
                slug = slug.split('?');
                slug = slug[0];
            }

            if (slug) {

                //set a global reference for the cache obj
                if (!window.slugCache) {
                    window.slugCache = $cacheFactory("slug-cache");
                }

                //refresh if cache found
                var cache = window.slugCache;
                var cachedSlug = cache.get(slug);

                if (cachedSlug != undefined) {

                    var urlType = bindDatawithStateParams(slug, cachedSlug, isInternalSlug);

                    urlType.cached = (cachedSlug.internal == isInternalSlug);

                    defer.resolve(urlType);
                } else {

                    var promise = httpHelper.g('profile/slug/' + slug, true).then(function (r) {
                        r = r.data;
                        if (r.status_code == 200) {
                            if(r.data?.is_archived){
                                defer.reject(slug);
                                return;
                            }
                            r.data.internal = !!isInternalSlug;
                            cache.put(slug, r.data);
                            var urlType = bindDatawithStateParams(slug, r.data, isInternalSlug);
                            urlType.cached = false;

                            defer.resolve(urlType);
                        } else {
                            defer.reject(slug);
                        }
                    }, function () {
                        defer.reject(slug);
                    });

                }

            } else {
                defer.reject(slug);
            }

            return defer.promise;
        }

        $locationProvider.html5Mode(true);
    }]);
